import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { REACT_APP_ACR_API_BASE_URL, REACT_APP_ACR_API_PROTOCOL } from "../utlities/core.constants";

export default function useProduct() {
  const [pscCodes, setPscCodes] = useState([]);

  const fetchCategories = useCallback(async () => {
    const response = await axios.get(`${REACT_APP_ACR_API_PROTOCOL}://${REACT_APP_ACR_API_BASE_URL}/api/category/all`);
    return response.data;
  }, []);

  const fetchPSCCodes = useCallback(async () => {
    const response = await axios.get(`${REACT_APP_ACR_API_PROTOCOL}://${REACT_APP_ACR_API_BASE_URL}/api/psc-code/all?pageSize=25&pageNumber=1`);
    return response.data;
  }, []);

  const submitProduct = useCallback(async (product) => {
    const response = axios.post(`${REACT_APP_ACR_API_PROTOCOL}://${REACT_APP_ACR_API_BASE_URL}/api/product`, product);

    return response;
  }, []);

  const saveDraftProduct = useCallback(async (product) => {
    const response = axios.post(`${REACT_APP_ACR_API_PROTOCOL}://${REACT_APP_ACR_API_BASE_URL}/api/product/draft`, product);

    return response;
  }, []);

  const fetchProduct = useCallback(async(productId) => {
    const response = axios.get(`${REACT_APP_ACR_API_PROTOCOL}://${REACT_APP_ACR_API_BASE_URL}/api/product?id=${productId}`);

    return (await response).data;
  }, [])
  const fetchProductList = useCallback(async (pageSize, newPage) => {
    const response = axios.get(`${REACT_APP_ACR_API_PROTOCOL}://${REACT_APP_ACR_API_BASE_URL}/api/product/all?pageSize=${pageSize}&pageNumber=${newPage}`);

    return (await response).data;
  }, []);

  // Only needed till results return total number before pagination
  const fetchProductAll = useCallback(async () => {
    const response = axios.get(`${REACT_APP_ACR_API_PROTOCOL}://${REACT_APP_ACR_API_BASE_URL}/api/product/all`);

    return (await response).data;
  }, []);

  // Needed till results return total number before pagination & used for product name search
  const fetchFilteredProductAll = useCallback(async (name, category, pscCode, vendorId = null, myListings = false) => {
    const response = axios.get(`${REACT_APP_ACR_API_PROTOCOL}://${REACT_APP_ACR_API_BASE_URL}/api/product/all?name=${name}&category=${category}&pscCode=${pscCode}${vendorId ? `&vendor=${vendorId}` : ""}&myListings=${myListings ? "true" : "false"}`);

    return (await response).data;
  }, []);

  const getProduct = useCallback(async (productId) => {
    const response = axios.get(`${REACT_APP_ACR_API_PROTOCOL}://${REACT_APP_ACR_API_BASE_URL}/api/product?id=${productId}`);

    return (await response).data
  }, [])

  // @TODO this updates the entire product with a new object instead of just changing the field that changed
  // which is the logic for a PUT, not PATCH. Done here due to time constraints. Needs to be fixed later.
  const updateProduct = useCallback(async (productId, product) => {
    const response = await axios.patch(`${REACT_APP_ACR_API_PROTOCOL}://${REACT_APP_ACR_API_BASE_URL}/api/product/${productId}`, product);

    return response;
  }, []);
  const fetchFedRampStatuses = useCallback(async () => {
    return ['N/A', 'In Progress', 'Approved'];
  }, []);

  useEffect(() => {
    (async () => {
      setPscCodes(await fetchPSCCodes());
    })();
  }, []);

  return { fetchCategories, pscCodes, fetchFedRampStatuses, submitProduct, saveDraftProduct, updateProduct, fetchProduct, fetchProductList, fetchProductAll, fetchFilteredProductAll, getProduct }
}
